export const APP_NAME = 'RetailXpert'
export const PERSIST_STORE_NAME = 'retailxpert_admin'
export const REDIRECT_URL_KEY = 'redirectUrl'